import { alpha, createTheme, responsiveFontSizes } from "@mui/material/styles";
const darkSlate = "#1F2D3D";
const paleGray = "#F4F6F8";
const primaryBlue = "#000048";
const white = "#FFFFFF";
const baseTheme = createTheme({
    palette: {
        mode: "light",
        primary: { main: primaryBlue, contrastText: white },
        secondary: { main: "#2E7D32", contrastText: white },
        background: { default: paleGray, paper: white },
        text: { primary: darkSlate, secondary: "#415563" },
        error: { main: "#D32F2F" },
    },
    typography: {
        fontFamily: 'Inter, Roboto, -apple-system, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
        body1: { fontSize: "0.95rem" },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: paleGray, // base background
                    color: darkSlate, // base text color
                    WebkitFontSmoothing: "antialiased",
                    MozOsxFontSmoothing: "grayscale",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    borderRadius: 6,
                },
                // MUI's default 4% text-button hover is all but invisible on the dialog's white paper.
                text: { ":hover": { backgroundColor: alpha(primaryBlue, 0.12) } },
            },
        },
    },
});
// The landing splash uses the cognizant.com CTA cyan and a near-black headline, not the in-app palette.
export const landingPalette = {
    // MAUI --bs-button-bg / --bs-accent3-medium (cognizant.com CTA cyan)
    accent: "#26EFE9",
    accentHover: "#06C7CC",
    accentTint: "rgba(38, 239, 233, 0.12)",
    headline: "#0F1720",
    // MAUI --bs-primary / --bs-secondary from neuro-san-ui globals.css
    header: primaryBlue,
    buttonHover: "#2E308E",
    buttonHoverShadow: "0 4px 14px rgba(0, 0, 72, 0.35)",
    // MAUI --bs-secondary / --link-color — readable link blue distinct from header primary
    link: "#2F78C4",
    linkHover: "#2566A8",
};
const theme = responsiveFontSizes(baseTheme);
export default theme;
